import { FormControl, InputLabel } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionChangeField } from "../../store/invoice/create/actions";
import { FieldWarehouseFC } from "./types";
const FieldWarehouse: FieldWarehouseFC = ({ saving }) => {
    const dispatch = useDispatch();
    const { activeWarehouses, value, error } = useSelector(
        ({
            currentUserInfo: { data },
            invoice: {
                create: { invoice, errors },
            },
        }) => ({
            value: invoice?.warehouse ?? null,
            error: errors?.warehouse ?? false,
            activeWarehouses: data && data.active_warehouses,
        })
    );
    const [options, setOptions] = useState([
        {
            id: 5,
            name: "Склад Черная Грязь",
        },
    ]);

    return (
        <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
                Выберите склад
            </InputLabel>
            <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={value}
                fullWidth
                error={error}
                label={"Выберите склад"}
                onChange={(e, value) => {
                    dispatch(
                        actionChangeField({
                            field: "warehouse",
                            value: e.target.value,
                        })
                    );
                }}
            >
                {options.map((warehouse) => (
                    <MenuItem key={warehouse.id} value={warehouse.id}>
                        {warehouse.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default FieldWarehouse;
